/**
 * @property title {string} component title name
 * @property subTitle {string} sub title
 * @property getUploadJson {function} the callback of upload function, which will pass promise object by param.
 * @property url {string} upload url
 * @property fieldName {string} field name for img
 * @property buttonLable {string} button label
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {buttonBlueColor} from '../../../utils/utility';
import Dropzone from 'react-dropzone';

class ImgUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyLogoErrorText: '',
      fileName: '',
      ifButtonEnable: false,
      newLogoBase64: ''
    }
  }
  handleDrop (files, accept, reject) {
    this.setState({
      fileName: files[0],
      ifButtonEnable: true,
      companyLogoErrorText: ''
    })
  }
  onDropRejected () {
    this.setState({
      companyLogoErrorText: 'Only jpg, png, and gif file with maximum size of 1MB is allowed'
    });
  }
  successCb (uploadFileName) {
    this.props.successCb(uploadFileName);
  }
  handleUpload () {
    if (this.state.ifButtonEnable) {
      let formData = new FormData();
      formData.append(this.props.fieldName, this.state.fileName);
      // call api
      fetch(this.props.url, {
        method: 'POST',
        body: formData
      })
        .then(
          (res) => {
            if (res.status === 200) {
              this.props.fieldName === 'avatar' ? this.props.getUploadJson(this.state.fileName) : this.props.getUploadJson(res.json());
              this.setState({
                companyLogoErrorText: '',
                newLogoBase64: this.state.fileName.preview
              })
            } else {
              res.json().then((json) => {
                this.setState({
                  companyLogoErrorText: json.message
                })
              })
            }
          },
          () => {

          }
        )
        // .then((json) => {
        //   if(typeof json !== 'undefined') {
        //     this.props.getUploadJson(json);
        //     this.setState({
        //       companyLogoErrorText: '',
        //       newLogoBase64: this.state.fileName.preview
        //     })
        //   }
        // })
        .catch((err) => {
          alert(err);
        })
    }
  }
  render () {
    return (
      <div className="profile-logo profile-logo-wrapper profile-company-logo clearfix">

        <div className="clearfix">
          <div className="title clearfix">
              <span id="profile-subtit">
                {this.props.title}
              </span>
          </div>
          <div className="review">
            <div className="profile-edit-img">
              <section className="section">{this.props.subTitle}</section>
              <Dropzone
                onDrop={(files, accept, reject) => this.handleDrop(files, accept, reject)}
                style={{width: '100%'}}
                accept="image/jpeg, image/png, image/jpg, image/gif"
                maxSize={1048576}
                onDropRejected={() => this.onDropRejected()}
                name="logo"
              >
                <p style={{textAlign: 'center', display: 'inline-block', width: '20%', height: '20px', fontSize: '12px', border: '1px solid grey', color: 'black', borderRadius: '6px', lineHeight: '20px', marginTop: '10px'}}>Choose File</p>
                {/*<i style={{fontStyle: 'normal', marginLeft: '6px'}}>{(this.state.logoFileName !== undefined && this.state.logoFileName.name) || 'No file chosen'}</i>*/}
                <i style={{fontStyle: 'normal', marginLeft: '6px'}}>{(this.state.fileName !== undefined && this.state.fileName.name) || 'No file chosen'}</i>
                <section className="spec">
                  (Only jpg, png, and gif file with maximum size of 1MB is allowed)
                </section>
              </Dropzone>
              <img src={this.state.newLogoBase64} alt=""/>
              <button style={{background: buttonBlueColor()}} onClick={() => this.handleUpload()}>{this.props.buttonLable}</button>
            </div>
          </div>
        </div>
        <div className="error" style={{bottom: '12px'}}>{this.state.companyLogoErrorText}</div>
      </div>
    )
  }
}

ImgUpload.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired
}

export default ImgUpload;


// WEBPACK FOOTER //
// ./src/components/framework/ImgUpload/ImgUpload.jsx